export default {
  'Add Cut': 'Add Cut',
}